import { DiscountList } from '@/screens/Cart/page/ui/discount-list/discount-list'

import { getCorrectProductName, getCorrectServiceName } from '@/shared/lib/utils/string/getCorrectName'
import { DiscountItem } from '@/shared/types/deprecated-types'
import Flex from '@/shared/ui/Flex/ui/Flex'

import { OrderInfoItem } from './components/order-info-item/order-info-item'

import cl from './order-info.module.scss'

export type OrderInfoProps = {
	productCount: number
	servicesCount: number
	totalSum: number
	promoCodeSum: number
	tradeInSum: number
	sale: number
	bonusPay: number
	basePrice: number
	isOrder?: boolean
	giftsCount?: number
	discountList?: DiscountItem[]
}

/**
 * Block with order price info in order page
 * @param props
 * @param props.productCount
 * @param props.servicesCount
 * @param props.totalSum
 * @param props.promoCodeSum
 * @param props.tradeInSum
 * @param props.sale
 * @param props.bonusScore
 * @param props.bonusPay
 */
export const OrderInfo = ({
	productCount,
	servicesCount,
	totalSum,
	promoCodeSum,
	tradeInSum,
	bonusPay,
	basePrice,
	giftsCount = 0,
	sale,
	discountList
}: OrderInfoProps): JSX.Element => (
	<section className={cl.orderInfo}>
		<Flex column>
			{/* Products count */}
			<OrderInfoItem
				title={`${productCount} ${getCorrectProductName(productCount)} ${
					servicesCount ? `, ${servicesCount} ${getCorrectServiceName(servicesCount)}` : ``
				}`}
				formatted
				value={basePrice}
			/>
			{!!giftsCount && <OrderInfoItem title="Подарок" value={`${giftsCount} шт.`} />}
			{/* Trade-in */}
			{!!tradeInSum && <OrderInfoItem accent title="Выгода с обменом в Трейд-ин" value={tradeInSum} formatted />}
			{/* Bonuses */}
			{!!bonusPay && <OrderInfoItem title="Оплата баллами" value={bonusPay} formatted />}
			{/* Promo code value */}
			{!!promoCodeSum && <OrderInfoItem title="Промокод" value={promoCodeSum} formatted />}

			{!!discountList?.length && <DiscountList items={discountList} price={sale} defaultOpen />}

			{/* Total sum (promoCodeSum/tradeInSum/bonusScore have negative values) */}
			<OrderInfoItem big title="Итог" value={totalSum + promoCodeSum + tradeInSum} formatted />
		</Flex>
	</section>
)
